import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { Navigation, Autoplay, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import 'swiper/swiper-bundle.css'
import { useTranslation } from 'react-i18next'

import img1 from 'resources/images/Banner1.jpg'
import img2 from 'resources/images/Banner2.jpg'
import img3 from 'resources/images/Banner3.jpg'
export default function BannerSwiper() {
    const [swiper, setSwiper] = useState(null)
    const [slideIndex, setSlideIndex] = useState(0)
    const { t } = useTranslation()
    const list = [
        { img: img1, title: 'home.bannerdesc' },
        { img: img2, title: 'home.bannerdesc2' },
        { img: img3, title: 'home.bannerdesc3' },
    ]
    return (
        <div>
            <h1 className='sr-only'>{t('home.bannerdesc2')}</h1>
            <Swiper
                loop={true}
                modules={[Navigation, Autoplay, Pagination]}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                spaceBetween={50}
                slidesPerView={1}
                onSwiper={(swiper) => {
                    setSwiper(swiper)
                }}
                onActiveIndexChange={(swiper) => {
                    setSlideIndex(swiper.realIndex)
                }}
                initialSlide={0}
            >
                {list.map((item, index) => (
                    <SwiperSlide key={index}>
                        <div className='relative aspect-video max-h-[820px] w-full'>
                            <img className='w-full h-full object-cover z-10  object-center' src={item.img} alt={t(item.title)} />
                        </div>
                        <div className='bg-black opacity-50 absolute top-0 bottom-0 left-0 right-0 z-20'></div>
                        <p className='text-2xl font-bold text-[#fff] z-20 absolute top-1/2 left-1/2 text-center -translate-x-1/2 -translate-y-1/2 w-[300px] md:w-[500px] md:text-5xl lg:w-[800px] lg:text-6xl'>
                            {t(item.title)}
                        </p>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}
